import * as React from 'react';

export const Questions: React.FC = () => {
  return (
    <div className="space-y-4">
      <h2 className="font-bold">Any questions?</h2>
      <p>
        Please contact{' '}
        <a href="mailto:contact@bluecargo.io" className="underline text-blue-900">
          support@bluecargo.io
        </a>{' '}
        for any questions you may have.
      </p>
    </div>
  );
};
Questions.displayName = 'UnsupportedRegion.Questions';
